import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import clsx from "clsx/lite";

const Cards = ({ data }) => (
	<div className="flex flex-col">
		<h3 className="pb-6">{data.title}</h3>
		<div className="flex flex-wrap gap-2">
			{data.items?.map((item, index) => (
				<div key={index}
					className={clsx(
						"flex flex-col lg:flex-1 p-5",
						item?.image ? "justify-start" : "justify-center",
						item.padding ? "w-[48.5%] last:w-full" : "w-full"
					)}
					style={{ backgroundColor: item.color?.hex }}
				>
					{item?.image &&
						<div className={clsx("mx-auto", item.padding ? "py-10 w-1/2 sm:w-1/3" : "w-1/3")}>
							<Image image={item.image} />
						</div>
					}
					{item?.content &&
						<div className="flex flex-col items-center justify-center text-center">
							<RichText data={{ content: item.content }} />
						</div>
					}
				</div>
			))}
		</div>
	</div>
);

export default Cards;